import React from 'react'
import ButtonComponent from '../../../../../components/Buttons/ButtonComponent';

import Grid from '@mui/material/Grid';

const ButtonARAgingReport = (props) => {
    return (
        <div className="row" spacing={'12px'}>
            <div className='col-12' spacing={'12px'}>
                <Grid container item spacing={'12px'} direction="row" style={{ 'maxWidth': '100vw', margin: '0px', columnGap: '8px', rowGap: '10px' }}>
                    {ButtonComponent.PrintButton(props.PrintData, 'PDF < 6 Months')}
                    {ButtonComponent.ExcelButton(props.PrintExcel, 'Print Excel < 6 Months')}
                    {ButtonComponent.PrintButton(props.PrintData2, 'PDF > 6 Months')}
                    {ButtonComponent.ExcelButton(props.PrintExcel2, 'Print Excel > 6 Months')}
                </Grid>
            </div>
        </div>
    )
}

export default ButtonARAgingReport;